import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';

import { RootStoreContext } from '../../../../../context';

import './Header.css';
import '../../../../../css/utils/flex.css';
import { anchorIsNakedNewsLive } from '../../../../../utils/helpers';
import AnchorDashboardStore from '../../../../../store/fragments/AnchorDashboardStore';


@observer
class Header extends Component {
  static contextType = RootStoreContext;

  getActiveConversationHeaderName = () => {
    const { fanAliases } = AnchorDashboardStore;
    const {
      privateMessagingStore: {
        activeConversationHeader,
        activeConversation,
      }
    } = this.context;

    if (!fanAliases) {
      return activeConversationHeader?.username;
    }

    const activeConversationUserDetails = activeConversation?.members?.
      find((member) => member?.nickname === activeConversationHeader?.username);

    return fanAliases?.[activeConversationUserDetails.username]?.displayUsername || activeConversationHeader?.username;
  }

  render() {
    const { currentAnchors } = this.props;
    const {
      privateMessagingStore: {
        activeConversationHeader,
        isBanned,
        memberAnchors,
        isConversationActive,
      },
      tippingStore,
      loggedInUser: {
        account: {
          anchor,
        },
      },
    } = this.context;

    const isAnchor = anchor;
    let showTipButton = false;
    let member = null;

    if (activeConversationHeader) {
      member = memberAnchors.find((anchor) =>
        anchor.username === activeConversationHeader.username ||
        anchor.nickname === activeConversationHeader.username
      );

      if (isConversationActive) {
        member = currentAnchors.find((anchor) =>
          anchor.id === activeConversationHeader.id
        );
      }

      if (member) {
        currentAnchors.forEach((anchor) => {
          if (anchor.id === member.id || anchorIsNakedNewsLive(member?.id)) {
            showTipButton = true;
          }
        });
      }
    }

    const handleTip = () => {
      tippingStore.setTippingModal({
        name: member?.name || activeConversationHeader.username,
        username: member?.username || activeConversationHeader.username,
        id: member?.id || activeConversationHeader.id,
      });
    };

    const activeConversationImageStyle = {};
    const hasImage = activeConversationHeader?.anchorImage;
    if (hasImage) {
      activeConversationImageStyle.background = `url(${activeConversationHeader.anchorImage}) no-repeat center center / cover`;
    }

    return (
      <header id="active-conversation-header">
        {activeConversationHeader && (
          <Fragment>
            <div className="flex items-center">
              <div
                className="avatar flex justify-center items-center"
                style={activeConversationImageStyle}
              >
                {!hasImage && activeConversationHeader.initials}
              </div>
              <div>
                <h4 className="username">{this.getActiveConversationHeaderName()}</h4>
                <p className="activity-label">
                  {activeConversationHeader.online && <span className="indicator" />}
                  <span>{activeConversationHeader.online ? 'Active now' : 'Inactive'}</span>
                </p>
              </div>
            </div>
            {!isAnchor && !isBanned && showTipButton && (
              <button
                className="btn btn-red tipping-btn"
                onClick={handleTip}
              >
                TIP $
              </button>
            )}
          </Fragment>
        )}
      </header>
    );
  }
}

export default Header;
